import { Component, Injector, OnInit, forwardRef } from '@angular/core';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { AIService } from '@app/shared/services/AI.service';
import { AiTextGenerationRequest } from '@app/shared/interfaces/ai-text-generation-request';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

@Component({
  selector: 'app-product-field-string',
  templateUrl: './product-field-string.component.html',
  styleUrls: ['./product-field-string.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldStringComponent),
      multi: true,
    },
  ],
})
export class ProductFieldStringComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor,OnInit
{
 
  aiLoading: boolean = false;
  value: string | null = null;
  ngControl: NgControl | null = null;
  constructor(private injector: Injector, private aiService: AIService) {
    super(injector);
  }
 
  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  writeValue(value: any): void {
    this.value = value;
    this.onChange(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  getNgControl() {
    if (!this.ngControl) {
      this.ngControl = this.injector.get(NgControl, null);
    }
  }

  get parentFormGroup(): FormGroup | null {
    this.getNgControl();
    if (this.ngControl?.control?.parent instanceof FormGroup) {
      return this.ngControl.control.parent as FormGroup;
    }
    return null;
  }
  
  
  getAIText() {
    this.aiLoading = true;
    let question: string = this.field.AdditionalData?.aigenerationQuestion;
    if (question == null) {
      this.message.error("This attribute doesn't have an AI question");
      this.aiLoading = false;
      return;
    }
    const params = this.route.snapshot.params;
    const id = params['id'];
    const request: AiTextGenerationRequest = {
      attributeId: +this.field.Code,
      objectId: +id,
      objectType: 12,
      includedAttributes: {},
      languageId: this.languageId,
    };

    this.aiService
      .getText(request, question, this.parentFormGroup!, this.controlName)
      .then(() => (this.aiLoading = false));
  }
}
